import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { getAssets, getDisplayAssets, isPutVault, VaultList, } from "../../constants/constants";
import sizes from "../../designSystem/sizes";
import { useLatestAPYs } from "../../hooks/useAirtableData";
import useScreenSize from "../../hooks/useScreenSize";
import useVaultAccounts from "../../hooks/useVaultAccounts";
import DesktopProductCatalogue from "./DesktopProductCatalogue";
import MobileProductCatalogue from "./MobileProductCatalogue";
import { VaultReleaseOrder, VaultSortByList, } from "./types";
var ProductCatalogue = function (_a) {
    var variant = _a.variant, onVaultPress = _a.onVaultPress;
    var width = useScreenSize().width;
    var _b = useState([]), filterStrategies = _b[0], setFilterStrategies = _b[1];
    var _c = useState([]), filterAssets = _c[0], setFilterAssets = _c[1];
    var _d = useState(VaultSortByList[0]), sort = _d[0], setSort = _d[1];
    var yieldsData = useLatestAPYs(VaultList);
    var vaultAccounts = useVaultAccounts(VaultList, "all").vaultAccounts;
    var filteredProducts = useMemo(function () {
        var filteredList = VaultList.filter(function (vault) {
            // Filter for strategies
            if (filterStrategies.length &&
                !filterStrategies.includes(isPutVault(vault) ? "PUT-SELLING" : "COVERED-CALL")) {
                return false;
            }
            // Filter for assets
            if (filterAssets.length &&
                !filterAssets.includes(getAssets(vault)) &&
                !filterAssets.includes(getDisplayAssets(vault))) {
                return false;
            }
            return true;
        });
        switch (sort) {
            case "NEWEST FIRST":
                filteredList.sort(function (a, b) {
                    return VaultReleaseOrder.indexOf(a) < VaultReleaseOrder.indexOf(b) ? 1 : -1;
                });
                break;
            case "OLDEST FIRST":
                filteredList.sort(function (a, b) {
                    return VaultReleaseOrder.indexOf(a) > VaultReleaseOrder.indexOf(b) ? 1 : -1;
                });
                break;
            case "YIELD: HIGH TO LOW":
                filteredList.sort(function (a, b) {
                    return yieldsData[a].res < yieldsData[b].res ? 1 : -1;
                });
                break;
            case "YIELD: LOW TO HIGH":
                filteredList.sort(function (a, b) {
                    return yieldsData[a].res > yieldsData[b].res ? 1 : -1;
                });
                break;
        }
        return filteredList;
    }, [filterAssets, filterStrategies, sort, yieldsData]);
    return width > sizes.md ? (_jsx(DesktopProductCatalogue, { variant: variant, onVaultPress: onVaultPress, filterStrategies: filterStrategies, filterAssets: filterAssets, sort: sort, setFilterStrategies: setFilterStrategies, setFilterAssets: setFilterAssets, setSort: setSort, filteredProducts: filteredProducts, vaultAccounts: vaultAccounts }, void 0)) : (_jsx(MobileProductCatalogue, { variant: variant, onVaultPress: onVaultPress, filterStrategies: filterStrategies, filterAssets: filterAssets, sort: sort, setFilterStrategies: setFilterStrategies, setFilterAssets: setFilterAssets, setSort: setSort, filteredProducts: filteredProducts, vaultAccounts: vaultAccounts }, void 0));
};
export default ProductCatalogue;
//# sourceMappingURL=ProductCatalogue.js.map